export function parseQueryToFilter(query) {
  const filter = {};
  if (query.activities) filter.activities = query.activities;
  if (query.starting_time) filter.starting_time = query.starting_time;
  if (query.price_from && query.price_to) {
    filter.price_from = query.price_from;
    filter.price_to = query.price_to;
  }
  return filter;
}

export function parseFilterToQuery(filter) {
  const queryStr = [];
  if (filter.activities) {
    queryStr.push(`activities=${filter.activities}`);
  }
  if (filter.starting_time) {
    queryStr.push(`starting_time=${filter.starting_time}`);
  }
  if (filter.price_from && filter.price_to) {
    queryStr.push(`price_from=${filter.price_from}&price_to=${filter.price_to}`);
  }
  return `${queryStr.length > 0 ? '?' : ''}${queryStr.join('&')}`;
}
